import type * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as dms from '../../../dms'
import { DIMENSION_ID } from '../constants'
import type { Feature } from '../feature'
import { Name } from '../name'

/**
 * Bootstraps entity-scoped Organization ECs from the DMS schema
 */
export const onSchemaChange = store.effects.create(
  (feature: Feature, schemaFeature: dms.schema.Feature) =>
    schemaFeature.selectors.schema.asObservable.pipe(
      rxjs.map(schema =>
        schema.getEntitiesInDimension(DIMENSION_ID).map(({ id }) => id),
      ),
      rxjs.distinctUntilChanged(areEntityIdsEqual),
      rxjsUtils.latestFrom(entityIds => ({
        collections: ec.Collection.instances.find({
          names: entityIds.flatMap(entityId => [
            Name.from(entityId),
            Name.All.from(entityId),
          ]),
        }).asObservable,
        entityIds: rxjs.of(entityIds),
      })),
      rxjs.mergeMap(({ entityIds, collections }) => {
        collections.forEach(collection =>
          collection.destroy('SpaceOrganizations.Registry.SchemaChanged'),
        )
        return entityIds.map(entityId =>
          feature.actions.bootstrap
            .from('SpaceOrganizations.Registry.SchemaChanged')
            .create({ entityId }),
        )
      }),
    ),
)

/**
 * Checks whether the Organization Entity ID list changed
 */
function areEntityIdsEqual(
  previous: readonly ents.core.dms.models.Entity.Id[],
  current: readonly ents.core.dms.models.Entity.Id[],
): boolean {
  return (
    previous.length === current.length &&
    previous.every((entityId, index) => entityId === current[index])
  )
}
